import { useMemo } from 'react';

import { useStudyCardState } from '../model/state/studyCardState';

export const useIsAssessmentCompleted = () => {
  const { data: card, received: cardReceived } = useStudyCardState();

  return useMemo(
    () => cardReceived && (!card || card.cycle === 'Review' || card.cycle === 'Survey' || card.cycle === 'Cram'),
    [card, cardReceived],
  );
};
